import React from 'react';
import styled from 'styled-components';
import { colors } from '@rezdy/components/utils/colors';

const getSpace = (x: number) => {
    return x * 2;
};

interface IAnswerProps {
    onClick: () => void;
    isSelected?: boolean;
}

const StyledAnswer = styled.div<IAnswerProps>(props => {
    const { theme, isSelected } = props;
    return {
        borderWidth: '2px',
        borderStyle: 'solid',
        borderRadius: '5px',
        borderColor: isSelected ? colors.blue[90] : colors.black[20],
        background: isSelected ? colors.blue[90] : '#fff',
        color: isSelected ? '#fff' : colors.black[90],
        fontFamily: theme.fontText,
        padding: `${getSpace(theme.x)}px`,
        textAlign: 'center',
    };
});

export default class Answer extends React.PureComponent<IAnswerProps> {
    render() {
        const { isSelected } = this.props;
        return (
            <StyledAnswer onClick={this.props.onClick} isSelected={isSelected}>
                {this.props.children}
            </StyledAnswer>
        );
    }
}
